import React, { useState, useContext, useEffect } from "react";

import { Layout, Row, Col, Card } from "antd";
import {
  Form,
  Input,
  Button,
  Typography,
  Select,
  Spin,
  Alert,
  notification,
} from "antd";
import axios from "axios";
import config from "../firebaseConfig";
import { UserContext } from "../providers/UserProvider";
export default function PaymentSettings() {
  const { user } = useContext(UserContext);
  const { Title, Text } = Typography;
  const { Option } = Select;
  const [paymentmethod, setpaymentmethod] = useState("");
  const [form] = Form.useForm();
  const [regex, setRegex] = useState({ number: "" });
  const paymentMethod = [
    "check",
    "electronic",
    "domesticWire",
    "internationalWire",
  ];
  const electronicAccountType = [
    "businessChecking",
    "businessSavings",
    "personalChecking",
    "personalSavings",
  ];
  const countryList = [
    { name: "Afghanistan", code: "AF" },
    { name: "Albania", code: "AL" },
    { name: "Algeria", code: "DZ" },
    { name: "American Samoa", code: "AS" },
    { name: "Andorra", code: "AD" },
    { name: "Angola", code: "AO" },
    { name: "Anguilla", code: "AI" },
    { name: "Antarctica", code: "AQ" },
    { name: "Antigua and Barbuda", code: "AG" },
    { name: "Argentina", code: "AR" },
    { name: "Armenia", code: "AM" },
    { name: "Aruba", code: "AW" },
    { name: "Australia", code: "AU" },
    { name: "Austria", code: "AT" },
    { name: "Azerbaijan", code: "AZ" },
    { name: "Bahamas", code: "BS" },
    { name: "Bahrain", code: "BH" },
    { name: "Bangladesh", code: "BD" },
    { name: "Barbados", code: "BB" },
    { name: "Belarus", code: "BY" },
    { name: "Belgium", code: "BE" },
    { name: "Belize", code: "BZ" },
    { name: "Benin", code: "BJ" },
    { name: "Bermuda", code: "BM" },
    { name: "Bhutan", code: "BT" },
    { name: "Bolivia (Plurinational State of)", code: "BO" },
    { name: "Bonaire, Sint Eustatius and Saba", code: "BQ" },
    { name: "Bosnia and Herzegovina", code: "BA" },
    { name: "Botswana", code: "BW" },
    { name: "Bouvet Island", code: "BV" },
    { name: "Brazil", code: "BR" },
    { name: "British Indian Ocean Territory", code: "IO" },
    { name: "Brunei Darussalam", code: "BN" },
    { name: "Bulgaria", code: "BG" },
    { name: "Burkina Faso", code: "BF" },
    { name: "Burundi", code: "BI" },
    { name: "Cabo Verde", code: "CV" },
    { name: "Cambodia", code: "KH" },
    { name: "Cameroon", code: "CM" },
    { name: "Canada", code: "CA" },
    { name: "Cayman Islands", code: "KY" },
    { name: "Central African Republic", code: "CF" },
    { name: "Chad", code: "TD" },
    { name: "Chile", code: "CL" },
    { name: "China", code: "CN" },
    { name: "Christmas Island", code: "CX" },
    { name: "Cocos (Keeling) Islands", code: "CC" },
    { name: "Colombia", code: "CO" },
    { name: "Comoros", code: "KM" },
    { name: "Congo, Democratic Republic of the", code: "CD" },
    { name: "Congo", code: "CG" },
    { name: "Cook Islands", code: "CK" },
    { name: "Costa Rica", code: "CR" },
    { name: "Croatia", code: "HR" },
    { name: "Cuba", code: "CU" },
    { name: "Curaçao", code: "CW" },
    { name: "Cyprus", code: "CY" },
    { name: "Czechia", code: "CZ" },
    { name: "Côte d'Ivoire", code: "CI" },
    { name: "Denmark", code: "DK" },
    { name: "Djibouti", code: "DJ" },
    { name: "Dominica", code: "DM" },
    { name: "Dominican Republic", code: "DO" },
    { name: "Ecuador", code: "EC" },
    { name: "Egypt", code: "EG" },
    { name: "El Salvador", code: "SV" },
    { name: "Equatorial Guinea", code: "GQ" },
    { name: "Eritrea", code: "ER" },
    { name: "Estonia", code: "EE" },
    { name: "Eswatini", code: "SZ" },
    { name: "Ethiopia", code: "ET" },
    { name: "Falkland Islands (Malvinas)", code: "FK" },
    { name: "Faroe Islands", code: "FO" },
    { name: "Fiji", code: "FJ" },
    { name: "Finland", code: "FI" },
    { name: "France", code: "FR" },
    { name: "French Guiana", code: "GF" },
    { name: "French Polynesia", code: "PF" },
    { name: "French Southern Territories", code: "TF" },
    { name: "Gabon", code: "GA" },
    { name: "Gambia", code: "GM" },
    { name: "Georgia", code: "GE" },
    { name: "Germany", code: "DE" },
    { name: "Ghana", code: "GH" },
    { name: "Gibraltar", code: "GI" },
    { name: "Greece", code: "GR" },
    { name: "Greenland", code: "GL" },
    { name: "Grenada", code: "GD" },
    { name: "Guadeloupe", code: "GP" },
    { name: "Guam", code: "GU" },
    { name: "Guatemala", code: "GT" },
    { name: "Guernsey", code: "GG" },
    { name: "Guinea", code: "GN" },
    { name: "Guinea-Bissau", code: "GW" },
    { name: "Guyana", code: "GY" },
    { name: "Haiti", code: "HT" },
    { name: "Heard Island and McDonald Islands", code: "HM" },
    { name: "Holy See", code: "VA" },
    { name: "Honduras", code: "HN" },
    { name: "Hong Kong", code: "HK" },
    { name: "Hungary", code: "HU" },
    { name: "Iceland", code: "IS" },
    { name: "India", code: "IN" },
    { name: "Indonesia", code: "ID" },
    { name: "Iran (Islamic Republic of)", code: "IR" },
    { name: "Iraq", code: "IQ" },
    { name: "Ireland", code: "IE" },
    { name: "Isle of Man", code: "IM" },
    { name: "Israel", code: "IL" },
    { name: "Italy", code: "IT" },
    { name: "Jamaica", code: "JM" },
    { name: "Japan", code: "JP" },
    { name: "Jersey", code: "JE" },
    { name: "Jordan", code: "JO" },
    { name: "Kazakhstan", code: "KZ" },
    { name: "Kenya", code: "KE" },
    { name: "Kiribati", code: "KI" },
    { name: "Korea (the Democratic People's Republic of)", code: "KP" },
    { name: "Korea (the Republic of)", code: "KR" },
    { name: "Kuwait", code: "KW" },
    { name: "Kyrgyzstan", code: "KG" },
    { name: "Lao People's Democratic Republic", code: "LA" },
    { name: "Latvia", code: "LV" },
    { name: "Lebanon", code: "LB" },
    { name: "Lesotho", code: "LS" },
    { name: "Liberia", code: "LR" },
    { name: "Libya", code: "LY" },
    { name: "Liechtenstein", code: "LI" },
    { name: "Lithuania", code: "LT" },
    { name: "Luxembourg", code: "LU" },
    { name: "Macao", code: "MO" },
    { name: "Madagascar", code: "MG" },
    { name: "Malawi", code: "MW" },
    { name: "Malaysia", code: "MY" },
    { name: "Maldives", code: "MV" },
    { name: "Mali", code: "ML" },
    { name: "Malta", code: "MT" },
    { name: "Marshall Islands", code: "MH" },
    { name: "Martinique", code: "MQ" },
    { name: "Mauritania", code: "MR" },
    { name: "Mauritius", code: "MU" },
    { name: "Mayotte", code: "YT" },
    { name: "Mexico", code: "MX" },
    { name: "Micronesia (Federated States of)", code: "FM" },
    { name: "Moldova (the Republic of)", code: "MD" },
    { name: "Monaco", code: "MC" },
    { name: "Mongolia", code: "MN" },
    { name: "Montenegro", code: "ME" },
    { name: "Montserrat", code: "MS" },
    { name: "Morocco", code: "MA" },
    { name: "Mozambique", code: "MZ" },
    { name: "Myanmar", code: "MM" },
    { name: "Namibia", code: "NA" },
    { name: "Nauru", code: "NR" },
    { name: "Nepal", code: "NP" },
    { name: "Netherlands", code: "NL" },
    { name: "New Caledonia", code: "NC" },
    { name: "New Zealand", code: "NZ" },
    { name: "Nicaragua", code: "NI" },
    { name: "Niger", code: "NE" },
    { name: "Nigeria", code: "NG" },
    { name: "Niue", code: "NU" },
    { name: "Norfolk Island", code: "NF" },
    { name: "Northern Mariana Islands", code: "MP" },
    { name: "Norway", code: "NO" },
    { name: "Oman", code: "OM" },
    { name: "Pakistan", code: "PK" },
    { name: "Palau", code: "PW" },
    { name: "Palestine, State of", code: "PS" },
    { name: "Panama", code: "PA" },
    { name: "Papua New Guinea", code: "PG" },
    { name: "Paraguay", code: "PY" },
    { name: "Peru", code: "PE" },
    { name: "Philippines", code: "PH" },
    { name: "Pitcairn", code: "PN" },
    { name: "Poland", code: "PL" },
    { name: "Portugal", code: "PT" },
    { name: "Puerto Rico", code: "PR" },
    { name: "Qatar", code: "QA" },
    { name: "Republic of North Macedonia", code: "MK" },
    { name: "Romania", code: "RO" },
    { name: "Russian Federation", code: "RU" },
    { name: "Rwanda", code: "RW" },
    { name: "Réunion", code: "RE" },
    { name: "Saint Barthélemy", code: "BL" },
    { name: "Saint Helena, Ascension and Tristan da Cunha", code: "SH" },
    { name: "Saint Kitts and Nevis", code: "KN" },
    { name: "Saint Lucia", code: "LC" },
    { name: "Saint Martin (French part)", code: "MF" },
    { name: "Saint Pierre and Miquelon", code: "PM" },
    { name: "Saint Vincent and the Grenadines", code: "VC" },
    { name: "Samoa", code: "WS" },
    { name: "San Marino", code: "SM" },
    { name: "Sao Tome and Principe", code: "ST" },
    { name: "Saudi Arabia", code: "SA" },
    { name: "Senegal", code: "SN" },
    { name: "Serbia", code: "RS" },
    { name: "Seychelles", code: "SC" },
    { name: "Sierra Leone", code: "SL" },
    { name: "Singapore", code: "SG" },
    { name: "Sint Maarten (Dutch part)", code: "SX" },
    { name: "Slovakia", code: "SK" },
    { name: "Slovenia", code: "SI" },
    { name: "Solomon Islands", code: "SB" },
    { name: "Somalia", code: "SO" },
    { name: "South Africa", code: "ZA" },
    { name: "South Georgia and the South Sandwich Islands", code: "GS" },
    { name: "South Sudan", code: "SS" },
    { name: "Spain", code: "ES" },
    { name: "Sri Lanka", code: "LK" },
    { name: "Sudan", code: "SD" },
    { name: "Suriname", code: "SR" },
    { name: "Svalbard and Jan Mayen", code: "SJ" },
    { name: "Sweden", code: "SE" },
    { name: "Switzerland", code: "CH" },
    { name: "Syrian Arab Republic", code: "SY" },
    { name: "Taiwan (Province of China)", code: "TW" },
    { name: "Tajikistan", code: "TJ" },
    { name: "Tanzania, United Republic of", code: "TZ" },
    { name: "Thailand", code: "TH" },
    { name: "Timor-Leste", code: "TL" },
    { name: "Togo", code: "TG" },
    { name: "Tokelau", code: "TK" },
    { name: "Tonga", code: "TO" },
    { name: "Trinidad and Tobago", code: "TT" },
    { name: "Tunisia", code: "TN" },
    { name: "Turkey", code: "TR" },
    { name: "Turkmenistan", code: "TM" },
    { name: "Turks and Caicos Islands", code: "TC" },
    { name: "Tuvalu", code: "TV" },
    { name: "Uganda", code: "UG" },
    { name: "Ukraine", code: "UA" },
    { name: "United Arab Emirates", code: "AE" },
    {
      name: "United Kingdom of Great Britain and Northern Ireland",
      code: "GB",
    },
    { name: "United States Minor Outlying Islands", code: "UM" },
    { name: "United States of America", code: "US" },
    { name: "Uruguay", code: "UY" },
    { name: "Uzbekistan", code: "UZ" },
    { name: "Vanuatu", code: "VU" },
    { name: "Venezuela (Bolivarian Republic of)", code: "VE" },
    { name: "Viet Nam", code: "VN" },
    { name: "Virgin Islands (British)", code: "VG" },
    { name: "Virgin Islands (U.S.)", code: "VI" },
    { name: "Wallis and Futuna", code: "WF" },
    { name: "Western Sahara", code: "EH" },
    { name: "Yemen", code: "YE" },
    { name: "Zambia", code: "ZM" },
    { name: "Zimbabwe", code: "ZW" },
    { name: "Åland Islands", code: "AX" },
  ];

  const onFinish = async (values) => {
    console.log(values);
    //   if(user) {
    //     axios
    // .post(
    //   `${config.apiUrl}/candidatesRequests-mercuryBank/`,
    //   {values}
    // ). then((res) => {
    //     console.log(res, "check data")
    // })
    // }
  };
  function handleChange(value) {
    console.log("check value", value);
    setpaymentmethod(value);
    console.log(value);
  }
  const prefixSelector = (
    <Form.Item name="prefix" noStyle>
      <Select style={{ width: 70 }}>
        <Option value="86">+86</Option>
        <Option value="87">+87</Option>
      </Select>
    </Form.Item>
  );

  return (
    <Layout style={{ minHeight: "100%", background: "#fbfbfb" }}>
      {/* <Spin spinning={isLoading} tip="Loading Profile..." size="large"> */}

      <Row justify="center" style={{ textAlign: "left" }} gutter={16}>
        <Col span={16}>
          <Card style={{ margin: "1.25rem 0rem" }}>
            <Row justify="left" gutter={16}>
              <Title
                style={{ margin: "0rem 0.25rem 1.25rem  0.25rem " }}
                level={4}
              >
                Banking Profile
              </Title>
            </Row>
            <Row justify="left" gutter={16}>
              <Text strong style={{ margin: "0rem 0.25rem 1.25rem  0.25rem " }}>
                Basic Information
              </Text>
            </Row>
            <Form form={form} name="" onFinish={onFinish}>
              <Row justify="center" gutter={16}>
                <Col span={12}>
                  <Text>Name:</Text>
                  <Form.Item
                    name="name"
                    rules={[
                      {
                        required: true,
                        message: "Please input your name!",
                      },
                    ]}
                  >
                    <Input name="name" placeholder="Name" />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Text>Email:</Text>
                  <Form.Item
                    name="email"
                    rules={[
                      {
                        required: true,
                        message: "Please input your Email!",
                      },
                    ]}
                  >
                    <Input name="email" placeholder="Email" />
                  </Form.Item>
                </Col>
              </Row>
              <Row justify="center" gutter={16}>
                <Col span={12}>
                  <Text>Address1:</Text>
                  <Form.Item
                    name="address1"
                    rules={[
                      {
                        required: true,
                        message: "Please input your Address1!",
                      },
                    ]}
                  >
                    <Input name="address1" placeholder="Address1" />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Text>Address2:</Text>
                  <Form.Item
                    name="address2"
                    rules={[
                      {
                        required: false,
                        message: "Please input your Address2!",
                      },
                    ]}
                  >
                    <Input name="address2" placeholder="Address2(Optional)" />
                  </Form.Item>
                </Col>
              </Row>
              <Row justify="center" gutter={16}>
                <Col span={12}>
                  <Text>City:</Text>
                  <Form.Item
                    name="city"
                    rules={[
                      {
                        required: true,
                        message: "Please input your City!",
                      },
                    ]}
                  >
                    <Input name="city" placeholder="City" />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Text>Region:</Text>
                  <Form.Item
                    name="region"
                    rules={[
                      {
                        required: false,
                        message: "Please input your Region!",
                      },
                    ]}
                  >
                    <Input name="region" placeholder="Region" />
                  </Form.Item>
                </Col>
              </Row>
              <Row justify="center" gutter={16}>
                <Col span={12}>
                  <Text>Country:</Text>
                  <Form.Item
                    name="country"
                    rules={[
                      {
                        required: true,
                        message: "Please input your country!",
                      },
                    ]}
                  >
                    <Select
                      name="country"
                      style={{ textAlign: "left" }}
                      showSearch
                      placeholder="Select Country "
                    >
                      {countryList.map((country, index) => {
                        return (
                          <Option key={index} value={country.code}>
                            {country.name + "(" + country.code + ")"}
                          </Option>
                        );
                      })}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Text>Postal Code:</Text>
                  <Form.Item
                    name="postalCode"
                    rules={[
                      {
                        required: true,
                        message: "Please input your country of Postal Code!",
                      },
                    ]}
                  >
                    <Input name="postalCode" placeholder="Postal Code" />
                  </Form.Item>
                </Col>
              </Row>
              <Row justify="left" gutter={16}>
                <Text
                  strong
                  style={{ margin: "0rem 0.25rem 1.25rem  0.25rem " }}
                >
                  Bank Information
                </Text>
              </Row>
              <Row justify="left" gutter={16}>
                <Col span={12}>
                  <Text>Payment Method:</Text>
                  <Form.Item
                    name="paymentMethod"
                    rules={[
                      {
                        required: true,
                        message: "Please input your country!",
                      },
                    ]}
                  >
                    <Select
                      name="paymentMethod"
                      style={{ textAlign: "left" }}
                      showSearch
                      placeholder="Select Payment Method "
                      onChange={handleChange}
                    >
                      {paymentMethod.map((method, index) => {
                        return (
                          <Option key={index} value={method}>
                            {method}
                          </Option>
                        );
                      })}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              {paymentmethod == "electronic" ? (
                <>
                  <Row justify="center" gutter={16}>
                    <Col span={12}>
                      <Text>Account No:</Text>
                      <Form.Item
                        name="accountNumber"
                        rules={[
                          {
                            required: true,
                            message: "Please input your Account Number!",
                          },
                          {
                            pattern: /^[0-9\b]+$/,
                            message: "Please enter numbers only",
                          },
                        ]}
                      >
                        <Input
                          maxLength={10}
                          name="accountNumber"
                          placeholder="Account No"
                        />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Text>Routing Number:</Text>
                      <Form.Item
                        name="routingNumber"
                        rules={[
                          {
                            required: false,
                            message: "Please input your Routing Number!",
                          },
                          {
                            pattern: /^[0-9\b]+$/,
                            message: "Please enter numbers only",
                          },
                        ]}
                      >
                        <Input
                          maxLength={9}
                          name="routingNumber"
                          placeholder="Routing Number"
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row justify="left" gutter={16}>
                    <Col span={12}>
                      <Text>Electronic Account Type:</Text>
                      <Form.Item
                        name="electroicType"
                        rules={[
                          {
                            required: true,
                            message:
                              "Please input your Electroic Account Type!",
                          },
                        ]}
                      >
                        <Select
                          name="electronicAccount"
                          style={{ textAlign: "left" }}
                          showSearch
                          placeholder="Select Electronic Account Type "
                        >
                          {electronicAccountType.map((account, index) => {
                            return (
                              <Option key={index} value={account}>
                                {account}
                              </Option>
                            );
                          })}
                        </Select>
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row justify="center" gutter={16}>
                    <Col span={12}>
                      <Text>Address1:</Text>
                      <Form.Item
                        name="electronicAddress1"
                        rules={[
                          {
                            required: true,
                            message: "Please input your Address1!",
                          },
                        ]}
                      >
                        <Input
                          name="electronicAddress1"
                          placeholder="Address1"
                        />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Text>Address2:</Text>
                      <Form.Item
                        name="electronicAddress2"
                        rules={[
                          {
                            required: false,
                            message: "Please input your Address2!",
                          },
                        ]}
                      >
                        <Input
                          name="electronicAddress2"
                          placeholder="Address2(Optional)"
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row justify="center" gutter={16}>
                    <Col span={12}>
                      <Text>City:</Text>
                      <Form.Item
                        name="electronicCity"
                        rules={[
                          {
                            required: true,
                            message: "Please input your City!",
                          },
                        ]}
                      >
                        <Input name="electronicCity" placeholder="City" />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Text>Region:</Text>
                      <Form.Item
                        name="electronicRegion"
                        rules={[
                          {
                            required: false,
                            message: "Please input your Region!",
                          },
                        ]}
                      >
                        <Input name="electronicRegion" placeholder="Region" />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row justify="center" gutter={16}>
                    <Col span={12}>
                      <Text>Country:</Text>
                      <Form.Item
                        name="Electroniccountry"
                        rules={[
                          {
                            required: true,
                            message: "Please input your country!",
                          },
                        ]}
                      >
                        <Select
                          name="ElectronicCountry"
                          style={{ textAlign: "left" }}
                          showSearch
                          placeholder="Select Country "
                        >
                          {countryList.map((country, index) => {
                            return (
                              <Option key={index} value={country.code}>
                                {country.name + "(" + country.code + ")"}
                              </Option>
                            );
                          })}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Text>Postal Code:</Text>
                      <Form.Item
                        name="electronicPostalCode"
                        rules={[
                          {
                            required: true,
                            message:
                              "Please input your country of Postal Code!",
                          },
                        ]}
                      >
                        <Input
                          name="electronicPostalCode"
                          placeholder="Postal Code"
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </>
              ) : (
                ""
              )}
              {paymentmethod == "internationalWire" ? (
                <>
                  <Row justify="center" gutter={16}>
                    <Col span={12}>
                      <Text>Iban:</Text>
                      <Form.Item
                        name="Iban"
                        rules={[
                          {
                            required: true,
                            message: "Please input your Iban !",
                          },
                          {
                            pattern: /^[A-Z0-9]+$/,
                            message: "fist two letters and digts",
                          },
                        ]}
                      >
                        <Input maxLength={34} name="Iban" placeholder="Iban" />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Text>Swift Code:</Text>
                      <Form.Item
                        name="swiftCode"
                        rules={[
                          {
                            required: true,
                            message: "Please input your Swift Code!",
                          },
                          {
                            pattern: /^[A-Z0-9]+$/,
                            message: "Enter Capital letter and numbers",
                          },
                        ]}
                      >
                        <Input name="swiftCode" placeholder="Swift Code" />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row justify="center" gutter={16}>
                    <Col span={12}>
                      <Text>Correspondent Routing Number:</Text>
                      <Form.Item
                        name="correspondentRoutingNumber"
                        rules={[
                          {
                            required: false,
                            message:
                              "Please input your correspondentRoutingNumber !",
                          },
                          {
                            pattern: /^[0-9\b]+$/,
                            message: "eneter numbers only",
                          },
                        ]}
                      >
                        <Input
                          maxLength={9}
                          name="Iban"
                          placeholder="Correspondent Routing Number(Optional)"
                        />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Text>Correspondent Swift:</Text>
                      <Form.Item
                        name="correspondentSwift"
                        rules={[
                          {
                            required: false,
                            message: "Please input your Correspondent Swift!",
                          },
                          {
                            pattern: /^[A-Z0-9]+$/,
                            message: "Enter Capital letter and numbers",
                          },
                        ]}
                      >
                        <Input
                          name="correspondentSwift"
                          placeholder="Correspondent Swift(Optional)"
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row justify="center" gutter={16}>
                    <Col span={12}>
                      <Text>Address1:</Text>
                      <Form.Item
                        name="InternationalWireAddress1"
                        rules={[
                          {
                            required: true,
                            message: "Please input your Address1!",
                          },
                        ]}
                      >
                        <Input
                          name="InternationalAddress1"
                          placeholder="Address1"
                        />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Text>Address2:</Text>
                      <Form.Item
                        name="InternationalWireAddress2"
                        rules={[
                          {
                            required: false,
                            message: "Please input your Address2!",
                          },
                        ]}
                      >
                        <Input
                          name="InternationalAddress2"
                          placeholder="Address2(Optional)"
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row justify="center" gutter={16}>
                    <Col span={12}>
                      <Text>City:</Text>
                      <Form.Item
                        name="internationaWireCity"
                        rules={[
                          {
                            required: true,
                            message: "Please input your City!",
                          },
                        ]}
                      >
                        <Input name="internationaWireCity" placeholder="City" />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Text>Region:</Text>
                      <Form.Item
                        name="internationalWireRegion"
                        rules={[
                          {
                            required: false,
                            message: "Please input your Region!",
                          },
                        ]}
                      >
                        <Input
                          name="internationalWireRegion"
                          placeholder="Region"
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row justify="center" gutter={16}>
                    <Col span={12}>
                      <Text>Country:</Text>
                      <Form.Item
                        name="internaltionalWireCountry"
                        rules={[
                          {
                            required: true,
                            message: "Please input your country!",
                          },
                        ]}
                      >
                        <Select
                          name="internaltionalWireCountry"
                          style={{ textAlign: "left" }}
                          showSearch
                          placeholder="Select Country "
                        >
                          {countryList.map((country, index) => {
                            return (
                              <Option key={index} value={country.code}>
                                {country.name + "(" + country.code + ")"}
                              </Option>
                            );
                          })}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Text>Postal Code:</Text>
                      <Form.Item
                        name="internationalWirePostalCode"
                        rules={[
                          {
                            required: true,
                            message:
                              "Please input your country of Postal Code!",
                          },
                        ]}
                      >
                        <Input
                          name="internationalWirePostalCode"
                          placeholder="Postal Code"
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row justify="center" gutter={16}>
                    <Col span={12}>
                      <Text>Phone Number:</Text>
                      <Form.Item
                        name="phoneNumber"
                        rules={[
                          {
                            required: false,
                            message: "Please input your Phone Number",
                          },
                          {
                            pattern: /^[+]{1}[0-9\b]+$/,
                            message: "start with country code",
                          },
                        ]}
                      >
                        {/* addonBefore={prefixSelector} */}
                        <Input
                          maxLength={12}
                          name="phoneNumber"
                          placeholder="phoneNumber(Optional)"
                        />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Text>Canadian Bank Code:</Text>
                      <Form.Item
                        name="canadianBankCode"
                        rules={[
                          {
                            required: false,
                            message: "Please input your Canadian Bank Code!",
                          },
                        ]}
                      >
                        <Input
                          name="canadianBankCode"
                          placeholder="Canadian Bank Code(Optional)"
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row justify="center" gutter={16}>
                    <Col span={12}>
                      <Text>Canadian Transit Number:</Text>
                      <Form.Item
                        name="canadianTransitNumber"
                        rules={[
                          {
                            required: false,
                            message:
                              "Please input your Canadian Transit Number",
                          },
                        ]}
                      >
                        <Input
                          name="canadianTransitNumber"
                          placeholder="Canadian Transit Number(Optional)"
                        />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Text>Australian BSB Code:</Text>
                      <Form.Item
                        name="australianBSBCode"
                        rules={[
                          {
                            required: false,
                            message: "Please input your Australian BSB Code!",
                          },
                        ]}
                      >
                        <Input
                          name="australianBSBCode"
                          placeholder="Australian BSB Code(Optional)"
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row justify="left" gutter={16}>
                    <Col span={12}>
                      <Text>Indian IFSC Code:</Text>
                      <Form.Item
                        name="indianIFSCCode"
                        rules={[
                          {
                            required: false,
                            message: "Please input your Indian IFSC Code",
                          },
                        ]}
                      >
                        <Input
                          name="indianIFSCCode"
                          placeholder="Indian IFSC Code(Optional)"
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </>
              ) : (
                ""
              )}
              {paymentmethod == "domesticWire" ? (
                <>
                  <Row justify="center" gutter={16}>
                    <Col span={12}>
                      <Text>Account No:</Text>
                      <Form.Item
                        name="accountNumber"
                        rules={[
                          {
                            required: true,
                            message: "Please input your Account Number!",
                          },
                          {
                            pattern: /^[0-9\b]+$/,
                            message: "Please enter numbers only",
                          },
                        ]}
                      >
                        <Input
                          maxLength={10}
                          name="accountNumber"
                          placeholder="Account No"
                        />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Text>Routing Number:</Text>
                      <Form.Item
                        name="routingNumber"
                        rules={[
                          {
                            required: false,
                            message: "Please input your Routing Number!",
                          },
                          {
                            pattern: /^[0-9\b]+$/,
                            message: "Please enter numbers only",
                          },
                        ]}
                      >
                        <Input
                          maxLength={9}
                          name="routingNumber"
                          placeholder="Routing Number"
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row justify="center" gutter={16}>
                    <Col span={12}>
                      <Text>Address1:</Text>
                      <Form.Item
                        name="domesticWireAddress1"
                        rules={[
                          {
                            required: true,
                            message: "Please input your Address1!",
                          },
                        ]}
                      >
                        <Input
                          name="domesticWireAddress1"
                          placeholder="Address1"
                        />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Text>Address2:</Text>
                      <Form.Item
                        name="domesticWireAddress2"
                        rules={[
                          {
                            required: false,
                            message: "Please input your Address2!",
                          },
                        ]}
                      >
                        <Input
                          name="domesticWireAddress2"
                          placeholder="Address2(Optional)"
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row justify="center" gutter={16}>
                    <Col span={12}>
                      <Text>City:</Text>
                      <Form.Item
                        name="domesticWireCity"
                        rules={[
                          {
                            required: true,
                            message: "Please input your City!",
                          },
                        ]}
                      >
                        <Input name="domesticWireCity" placeholder="City" />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Text>Region:</Text>
                      <Form.Item
                        name="domesticWireRegion"
                        rules={[
                          {
                            required: false,
                            message: "Please input your Region!",
                          },
                        ]}
                      >
                        <Input name="domesticWireRegion" placeholder="Region" />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row justify="center" gutter={16}>
                    <Col span={12}>
                      <Text>Country:</Text>
                      <Form.Item
                        name="domesticWireCountry"
                        rules={[
                          {
                            required: true,
                            message: "Please input your country!",
                          },
                        ]}
                      >
                        <Select
                          name="domesticWireCountry"
                          style={{ textAlign: "left" }}
                          showSearch
                          placeholder="Select Country "
                        >
                          {countryList.map((country, index) => {
                            return (
                              <Option key={index} value={country}>
                                {country}
                              </Option>
                            );
                          })}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Text>Postal Code:</Text>
                      <Form.Item
                        name="postalCode"
                        rules={[
                          {
                            required: true,
                            message:
                              "Please input your country of Postal Code!",
                          },
                        ]}
                      >
                        <Input name="postalCode" placeholder="Postal Code" />
                      </Form.Item>
                    </Col>
                  </Row>
                </>
              ) : (
                ""
              )}
              <Col span={24}>
                <Form.Item
                  style={{ margin: "0px" }}
                  justify="center"
                  shouldUpdate={true}
                >
                  {() => (
                    <Button type="primary" htmlType="submit">
                      Save & Update
                    </Button>
                  )}
                </Form.Item>
              </Col>
            </Form>
          </Card>
        </Col>
      </Row>
      {/* </Spin> */}
    </Layout>
  );
}
